import { PhoneDialIcon } from './PhoneDialIcon';

/**
 * author: François Risoud
 * id 8F4DBE23-BD53-447F-917D-5343B4DDE8B8
 * name phone-dial
 * version: 5.5.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/phone-dial.svg
 * tags
 * - Cellphone / Phone 
 */
export const PhoneKeypadIcon = PhoneDialIcon;
export default PhoneKeypadIcon